<template>
  <div class="el-input-number el-input-number--mini is-controls-right">
    <span class="el-input-number__decrease" @click="onDecrease">
      <i class="el-icon-arrow-down" />
    </span>
    <span class="el-input-number__increase" @click="onIncrease">
      <i class="el-icon-arrow-up" />
    </span>
    <el-input :value="formatValue" type="number" @focus="onFocus" @input="onInput" @blur="onBlur" />
  </div>
</template>

<script>
export default {
  name: 'CargoNumericStepper',
  props: {
    value: { type: [String, Number], required: true },
    minimum: { type: Number, default: null },
    maximum: { type: Number, default: null },
    valueFormatFunction: { type: Function, default: null },
    valueParseFunction: { type: Function, default: null }
  },
  data() {
    return {
      focused: false
    }
  },
  computed: {
    formatValue() {
      if (!this.focused) {
        if (typeof this.valueFormatFunction === 'function') {
          return this.valueFormatFunction(this.value)
        }
      }
      return this.value
    }
  },
  methods: {
    onFocus() {
      this.onInput(this.formatValue)
      this.focused = true
    },
    onInput(val) {
      this.$emit('input', val)
    },
    onBlur() {
      this.focused = false
      this.checkAndParseValue(this.value)
    },
    checkAndParseValue(val) {
      val = Number(val) || 0
      if (typeof this.minimum === 'number') {
        if (val < this.minimum) {
          val = this.minimum
        }
      }
      if (typeof this.maximum === 'number') {
        if (val > this.maximum) {
          val = this.maximum
        }
      }
      if (typeof this.valueParseFunction === 'function') {
        val = this.valueParseFunction(val)
      }
      this.onInput(val)
    },
    onDecrease() {
      this.checkAndParseValue((Number(this.formatValue) || 0) - 1)
    },
    onIncrease() {
      this.checkAndParseValue((Number(this.formatValue) || 0) + 1)
    }
  }
}
</script>
